<div style="overflow: auto" class="{{ theme$ | async }}">
  @if (loading) {
    <div
    style="
      width: 100%;
      min-height: 500px;
      background-color: var(--card);
      flex: 1;
      justify-content: center;
      justify-items: center;
    "
      >
      <div style="left: 45%; top: 30%; position: absolute">
        {{ "COMMON.LOADING" | translate }}
      </div>
    </div>
  }
  @if (!loading) {
    <div>
      <div class="row">
        @if (availabilitySelected) {
          <div
        style="
          display: flex;
          justify-content: space-around;
          margin-top: 5px;
          margin-bottom: 5px;
          width: 100%;
        "
            >
            <span class="legend-1">
              <span class="dot-1"></span>
              {{ availabilitySelected?.label ?? "" }}
            </span>
            @if (tooltipData.target >= 0) {
              <span class="legend-3">
                <span class="solid-legend"></span>
                {{ availabilitySelected?.label ?? "" }}
                {{
                tooltipData.target >= 0
                ? " (" + ("COMMON.TARGET" | translate) + ")"
                : lastYear
                }}
              </span>
            }
          </div>
        }
      </div>
      <div class="row" style="min-height: 250px; margin:20px 0; position: relative;">
        <highcharts-chart
          [id]="chartId"
          class="w-100 d-block"
          [Highcharts]="highcharts"
          [options]="chartOptions"
          [callbackFunction]="chartCallback">
        </highcharts-chart>
      </div>
    </div>
  }
</div>
